var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOTpatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 403,
    viewBox: "0 0 187 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.818 20.4966H10.3906V402.88H180.818C182.25 402.899 183.632 402.35 184.659 401.351C185.685 400.353 186.274 398.988 186.294 397.556V25.8207C186.274 24.3886 185.685 23.0233 184.658 22.0249C183.632 21.0265 182.25 20.4768 180.818 20.4966Z",
    fill: "#BDD2DC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.725 20.498H10.3906V398.459H172.725C174.115 398.453 175.445 397.895 176.423 396.908C177.401 395.921 177.947 394.586 177.941 393.196V25.7606C177.947 24.3711 177.401 23.0361 176.423 22.0491C175.445 21.0622 174.115 20.5043 172.725 20.498Z",
    fill: "#BDD2DC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8047 0H164.476C165.891 0 167.248 0.562168 168.249 1.56284C169.249 2.56352 169.812 3.92073 169.812 5.3359V386.919C169.812 388.334 169.249 389.691 168.249 390.692C167.248 391.692 165.891 392.255 164.476 392.255H10.8048C9.38957 392.255 8.03233 391.692 7.03163 390.692C6.03094 389.691 5.46875 388.334 5.46875 386.919V5.3359C5.46875 3.92073 6.03093 2.56352 7.0316 1.56284C8.03228 0.562168 9.38949 0 10.8047 0Z",
    fill: "#D1E6F4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7624 3.55176C65.7871 5.18554 52.9469 7.75499 40.3421 11.2401C40.3421 11.2401 32.4819 10.1214 30.7255 12.916C28.9693 15.7105 34.0339 23.372 34.0339 23.372C34.0339 23.372 32.9492 58.3307 35.734 63.2601C35.4684 69.1932 36.6692 74.8122 39.9672 76.264C43.2652 77.7158 69.2143 74.9187 89.051 74.0063C108.888 73.0938 132.428 75.5881 136.525 73.9194C140.622 72.2507 140.806 70.6996 141.151 66.4898C141.496 62.28 133.725 17.8328 131.366 13.3773C131.855 10.7666 135.563 3.25326 129.277 1.22816C122.991 -0.796942 98.3828 1.09786 78.7624 3.55176Z",
    fill: "#F1F5F7"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.271 1.42029C66.2413 2.42533 53.2984 4.34543 40.538 7.16639C40.538 7.16639 32.7375 5.72988 30.8547 8.36358C28.9719 10.9973 33.679 18.6587 33.679 18.6587C33.679 18.6587 30.9892 52.537 33.5445 57.4452C33.0065 63.1913 33.9479 68.698 37.1757 70.2542C40.4035 71.8104 66.4538 70.2542 86.3113 70.2542C106.169 70.2542 129.57 73.7259 133.739 72.2893C137.909 70.8527 138.164 69.3557 138.702 65.2855C139.239 61.2153 133.52 17.7333 131.368 13.304C131.976 10.7922 136.026 3.66619 129.839 1.42029C123.653 -0.825614 98.9833 -0.0854139 79.271 1.42029Z",
    fill: "#F1F5F7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3515 40.2402C70.9786 42.9401 63.523 47.9183 57.8203 54.617",
    stroke: "#8BAFC0",
    strokeWidth: 0.84067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5078 14.5645C59.5078 14.5645 69.514 17.5123 72.1641 33.8891C72.3349 34.9449 72.4678 35.9826 72.5627 37.0024",
    stroke: "#8BAFC0",
    strokeWidth: 0.84067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5234 32.0786C90.5234 32.0786 96.5861 20.2631 108.452 18.9551",
    stroke: "#8BAFC0",
    strokeWidth: 0.84067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5938 48.891C91.5938 48.891 105.605 46.0888 115.413 54.3554",
    stroke: "#8BAFC0",
    strokeWidth: 0.84067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6548 395.673H165.139C167.711 395.674 170.185 394.691 172.056 392.926C173.926 391.161 175.052 388.748 175.201 386.181C177.114 353.45 174.181 280.79 174.641 263.716C175.201 242.932 174.516 198.089 173.52 170.834C172.911 154.158 172.399 134.243 172.399 134.243C172.399 134.243 123.444 120.664 90.7211 120.664C57.9979 120.664 3.50308 136.755 3.50308 136.755L2.18008 143.227C2.18008 143.227 0.910085 171.044 0.439085 185.136C-0.0319153 199.229 1.82178 239.429 1.01178 259.57C0.394877 274.909 -1.20452 355.836 1.61818 386.509C1.84668 389.013 3.00286 391.342 4.85978 393.037C6.7167 394.733 9.14027 395.673 11.6548 395.673Z",
    fill: "#1877A1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M110.332 173.73C110.03 174.767 109.644 175.778 109.18 176.753C106.592 182.42 98.8425 194.889 78.2461 203.955",
    stroke: "#57A0D8",
    strokeWidth: 1.68134,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.513 173.73C137.513 173.73 135.398 195.515 139.538 213.346",
    stroke: "#57A0D8",
    strokeWidth: 1.68134,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6747 30.6702C69.6747 30.6702 67.3249 27.1128 64.317 27.7859C61.3091 28.459 63.659 37.7289 65.9619 40.1606C68.2648 42.5923 72.1656 41.6788 72.1656 41.6788L69.6747 30.6702Z",
    fill: "#B46F4C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5026 30.6702C97.5026 30.6702 99.8525 27.1128 102.86 27.7859C105.868 28.459 103.518 37.7289 101.215 40.1606C98.9125 42.5923 95.0117 41.6788 95.0117 41.6788L97.5026 30.6702Z",
    fill: "#B46F4C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8279 119.834L34.3553 135.391C30.4582 138.071 26.1222 140.048 21.5436 141.233C13.8807 143.232 2.18057 142.326 2.18057 142.326C2.18057 142.326 1.36507 142.667 0.848767 140.434C0.332466 138.201 1.16167 130.293 0.902874 127.986C0.706574 126.237 2.35677 125.464 3.78547 125.558C7.96216 125.847 12.1575 125.705 16.3051 125.134C21.1579 124.289 27.8279 119.834 27.8279 119.834Z",
    fill: "#C4DCF0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M144.397 119.719L136.887 135.391C141.286 138.059 146.099 139.977 151.128 141.066C159.666 142.963 172.757 141.894 172.757 141.894C172.757 141.894 173.663 142.224 174.271 139.981C174.879 137.737 174.635 125.417 173.116 124.908C170.646 124.079 162.617 125.649 157.204 124.869C151.791 124.089 144.397 119.719 144.397 119.719Z",
    fill: "#C4DCF0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5882 62.8637C96.7997 61.2442 96.2328 59.5258 95.9029 57.755C89.0849 55.4877 81.489 55.4533 75.3173 59.1151C75.2708 59.6309 75.215 60.1081 75.148 60.5249C74.6093 63.8768 64.793 69.9223 64.793 69.9223C64.793 69.9223 72.1806 83.7822 87.892 83.7822C103.603 83.7822 108.451 69.4175 108.451 69.4175C108.451 69.4175 99.3837 65.6467 97.5882 62.8637Z",
    fill: "#C3886A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M146.736 202.607C147.396 198.833 154.896 155.851 154.864 150.073C154.83 144.029 154.361 142.577 154.07 141.149C153.384 135.018 151.396 116.158 151.396 116.158L130.288 122.624C130.288 122.624 133.157 138.521 134.961 144.651C135.059 153.36 134.657 162.253 135.579 170.892C136.502 179.531 135.901 202.549 135.901 202.549C135.725 203.047 135.497 203.707 135.444 203.917L135.357 204.267L134.859 206.173C134.859 206.173 132.592 210.458 132.106 211.681C131.62 212.905 130.174 218.108 129.318 218.979C128.462 219.849 128.234 219.724 128.234 219.724C128.234 219.724 129.036 221.122 130.046 220.781C130.634 220.463 131.194 220.095 131.719 219.682C132.563 218.974 133.265 218.112 133.788 217.142C134.377 218.933 134.669 220.808 134.653 222.693C134.605 223.114 134.66 223.54 134.814 223.934C134.709 225.309 134.514 226.676 134.231 228.026C133.739 229.867 132.318 234.108 132.318 234.108C132.162 235.269 134.24 235.548 134.396 234.387C134.396 234.387 136.258 229.839 136.915 228.051C137.101 227.503 137.256 226.945 137.379 226.38C137.305 227 137.195 227.615 137.05 228.223C136.558 230.063 135.137 234.304 135.137 234.304C134.981 235.465 137.06 235.744 137.216 234.583C137.216 234.583 139.078 230.035 139.735 228.247C140.096 227.092 140.382 225.914 140.592 224.722C140.5 225.696 140.347 226.663 140.134 227.619C139.642 229.459 138.221 233.7 138.221 233.7C138.065 234.861 140.143 235.14 140.299 233.979C140.299 233.979 142.161 229.431 142.818 227.643C143.132 226.66 143.384 225.657 143.571 224.642C143.493 225.377 143.37 226.106 143.204 226.827C142.742 228.555 141.407 232.539 141.407 232.539C141.26 233.629 143.213 233.891 143.359 232.801C143.359 232.801 145.108 228.529 145.725 226.85C146.193 225.262 146.558 223.645 146.816 222.009C146.84 221.986 146.873 221.962 146.895 221.94C147.479 220.058 147.841 218.114 147.973 216.149L146.945 202.62L146.736 202.607Z",
    fill: "#10548A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.1406 203.027C39.2052 199.312 28.5753 156.995 28.1838 151.23C27.7741 145.2 28.1357 143.718 28.3215 142.272C28.5562 136.107 29.1558 117.152 29.1558 117.152L50.6809 122.054C50.6809 122.054 48.9851 138.118 47.636 144.364C48.1766 153.057 49.2293 161.896 48.9421 170.58C48.6551 179.263 50.9422 202.175 50.9422 202.175C51.1539 202.659 51.43 203.3 51.4976 203.505L51.6104 203.849L52.2464 205.713C52.2464 205.713 54.8212 209.821 55.3959 211.005C55.9706 212.189 57.7938 217.272 58.7111 218.078C59.6286 218.883 59.8467 218.742 59.8467 218.742C59.8467 218.742 59.1492 220.195 58.1172 219.929C57.5077 219.654 56.9226 219.329 56.3683 218.955C55.4744 218.311 54.7109 217.503 54.1185 216.573C53.6622 218.403 53.5084 220.294 53.6632 222.173C53.7418 222.589 53.7179 223.018 53.5934 223.423C53.7994 224.787 54.0938 226.136 54.475 227.461C55.1004 229.261 56.8287 233.386 56.8287 233.386C57.0693 234.533 55.0167 234.964 54.776 233.817C54.776 233.817 52.5858 229.418 51.7993 227.683C51.5741 227.15 51.3789 226.605 51.2146 226.05C51.3341 226.663 51.4886 227.269 51.6775 227.864C52.303 229.663 54.0313 233.788 54.0313 233.788C54.2719 234.935 52.2192 235.366 51.9786 234.219C51.9786 234.219 49.7883 229.82 49.0019 228.085C48.5569 226.959 48.1851 225.806 47.8888 224.632C48.0517 225.597 48.2752 226.551 48.5581 227.487C49.1835 229.287 50.9118 233.412 50.9118 233.412C51.1525 234.559 49.0999 234.99 48.8591 233.843C48.8591 233.843 46.6689 229.444 45.8824 227.709C45.497 226.751 45.1728 225.769 44.9119 224.77C45.0437 225.498 45.2194 226.216 45.4381 226.923C46.0256 228.613 47.6488 232.487 47.6488 232.487C47.8748 233.564 45.947 233.969 45.7209 232.892C45.7209 232.892 43.6638 228.76 42.9251 227.131C42.342 225.581 41.8602 223.995 41.4826 222.383C41.4567 222.362 41.4221 222.34 41.3991 222.319C40.6786 220.485 40.1751 218.574 39.8989 216.623L39.9331 203.055L40.1406 203.027Z",
    fill: "#10548A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0882 121.547C28.0882 121.547 26.6229 141.03 25.9689 143.737C25.3149 146.444 26.4013 152.189 27.328 154.515C28.0815 161.207 38.5485 203.778 38.5485 203.778L49.4373 204.767C49.4373 204.767 48.7602 166.355 48.0629 160.109C47.4577 155.567 46.518 151.076 45.2514 146.672L49.1202 125.771L28.0882 121.547Z",
    fill: "#C3886A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3852 203.199C49.3852 203.199 49.9534 204.817 50.0379 205.168L50.1225 205.52L50.6046 207.43C50.6046 207.43 52.8366 211.733 53.3131 212.96C53.7896 214.187 55.1929 219.402 56.0416 220.279C56.8903 221.157 57.1194 221.034 57.1194 221.034C57.1194 221.034 56.306 222.425 55.2989 222.076C54.7138 221.753 54.1572 221.381 53.6351 220.963C52.7966 220.248 52.1015 219.381 51.5866 218.406C50.9829 220.192 50.6756 222.065 50.677 223.951C50.855 226.301 48.8338 226.556 47.0864 226.415C45.339 226.273 39.6509 224.393 38.4418 223.098C37.8729 221.211 37.5267 219.265 37.4102 217.298L38.5484 203.778L49.3852 203.199Z",
    fill: "#C3886A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3465 221.098C41.4598 223.415 41.708 225.725 42.0898 228.013C42.5378 229.746 43.8402 233.74 43.8402 233.74C43.9778 234.831 42.0234 235.078 41.8858 233.986C41.8858 233.986 40.1718 229.701 39.5682 228.016C38.9798 225.772 38.5227 223.495 38.1992 221.197L41.3465 221.098Z",
    fill: "#C3886A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3626 221.469C44.4832 223.936 44.7474 226.395 45.1539 228.832C45.6309 230.676 47.0177 234.929 47.0177 234.929C47.1643 236.091 45.0834 236.353 44.9368 235.191C44.9368 235.191 43.1119 230.628 42.4692 228.835C41.8428 226.445 41.3561 224.021 41.0117 221.574L44.3626 221.469Z",
    fill: "#C3886A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4409 222.098C47.5615 224.565 47.8257 227.024 48.2323 229.461C48.7093 231.305 50.096 235.558 50.096 235.558C50.2426 236.72 48.1615 236.982 48.015 235.82C48.015 235.82 46.1901 231.257 45.5475 229.464C44.921 227.074 44.4343 224.65 44.0898 222.203L47.4409 222.098Z",
    fill: "#C3886A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2612 221.924C50.3817 224.391 50.646 226.85 51.0525 229.287C51.5295 231.131 52.9162 235.384 52.9162 235.384C53.0629 236.546 50.9819 236.808 50.8354 235.646C50.8354 235.646 49.0104 231.083 48.3678 229.29C47.7413 226.9 47.2546 224.476 46.9102 222.029L50.2612 221.924Z",
    fill: "#C3886A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M138.195 201.889C138.195 201.889 137.639 203.511 137.557 203.863L137.475 204.215L137.007 206.128C137.007 206.128 134.807 210.448 134.34 211.679C133.873 212.909 132.508 218.134 131.666 219.018C130.824 219.902 130.594 219.78 130.594 219.78C130.594 219.78 131.418 221.165 132.422 220.809C133.005 220.482 133.558 220.105 134.077 219.684C134.911 218.963 135.599 218.09 136.107 217.112C136.724 218.893 137.045 220.764 137.058 222.649C136.897 225.001 138.92 225.241 140.667 225.086C142.413 224.932 148.087 223.01 149.286 221.705C149.841 219.815 150.173 217.866 150.275 215.898L149.036 202.387L138.195 201.889Z",
    fill: "#C3886A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M146.363 219.727C146.267 222.045 146.036 224.356 145.671 226.648C145.236 228.383 143.963 232.387 143.963 232.387C143.834 233.479 145.79 233.711 145.919 232.619C145.919 232.619 147.601 228.32 148.192 226.632C148.764 224.383 149.204 222.102 149.511 219.802L146.363 219.727Z",
    fill: "#C3886A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.35 220.119C143.248 222.588 143.002 225.048 142.614 227.488C142.151 229.336 140.796 233.599 140.796 233.599C140.658 234.762 142.741 235.009 142.878 233.846C142.878 233.846 144.669 229.269 145.299 227.471C145.907 225.077 146.376 222.649 146.702 220.2L143.35 220.119Z",
    fill: "#C3886A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M140.276 220.771C140.174 223.24 139.928 225.7 139.54 228.14C139.076 229.988 137.721 234.251 137.721 234.251C137.583 235.414 139.666 235.661 139.804 234.498C139.804 234.498 141.595 229.921 142.224 228.123C142.833 225.729 143.302 223.301 143.628 220.852L140.276 220.771Z",
    fill: "#C3886A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M137.456 220.619C137.354 223.088 137.108 225.548 136.719 227.988C136.256 229.836 134.901 234.099 134.901 234.099C134.763 235.262 136.846 235.509 136.984 234.346C136.984 234.346 138.775 229.769 139.404 227.971C140.013 225.577 140.481 223.149 140.807 220.7L137.456 220.619Z",
    fill: "#C3886A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M131.137 122.661C131.137 122.661 134.253 138.511 136.151 144.612C136.385 153.319 136.121 162.217 137.178 170.841C138.236 179.464 137.992 202.489 137.992 202.489L148.784 202.648C148.784 202.648 156.264 155.767 156.136 149.724C156.009 143.682 155.517 142.237 155.204 140.813C154.422 134.693 152.141 115.867 152.141 115.867L131.137 122.661Z",
    fill: "#C3886A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4903 123.991C31.6993 122.299 27.6295 119.023 24.9544 114.703C23.9376 118.233 23.25 120.68 23.25 120.68C23.25 120.68 24.866 125.977 36.4476 129.927C44.5001 132.674 48.5112 133.423 50.211 133.625L50.7116 127.143C50.7116 127.143 45.6677 127.143 36.4903 123.991Z",
    fill: "#E5F7FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M129.594 121.82L130.213 128.82C134.749 127.7 139.176 126.178 143.441 124.271C152.175 120.254 154.874 116.969 154.874 116.969C154.874 116.969 154.315 114.276 153.369 110.48C146.159 118.318 129.594 121.82 129.594 121.82Z",
    fill: "#E5F7FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M153.369 110.481C151.8 104.184 149.167 94.8512 146.254 89.7349C141.585 81.5346 138.054 79.0806 132.547 75.8483C130.236 74.4919 121.197 71.2391 114.001 68.3516L87.6371 90.3655L60.6912 70C56.1918 72.6148 50.8084 75.5785 48.3303 76.8061C41.9257 79.9784 35.0098 84.411 32.5858 90.2466C30.9259 94.2427 27.1617 107.035 24.9531 114.705C27.6282 119.024 31.698 122.301 36.489 123.992C45.6664 127.145 50.7103 127.145 50.7103 127.145L50.2097 133.626L50.2845 133.758L50.3454 137.081C50.3454 137.081 62.2247 131.811 90.9583 131.811C119.692 131.811 129.03 135.403 129.03 135.403L130.213 132.711V128.821L129.593 121.821C129.593 121.821 146.159 118.319 153.369 110.481Z",
    fill: "#C4EDFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M114.001 68.3505C110.98 67.1383 108.281 65.99 106.545 65.0742L87.9265 83.1487L66.298 66.603C64.9674 67.4737 62.9377 68.6936 60.6914 69.9989L87.6373 90.3644L114.001 68.3505Z",
    fill: "#75AEC6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M127.774 101.574C127.774 101.574 125.672 113.905 127.213 119.719",
    stroke: "#75AEC6",
    strokeWidth: 0.84067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M130.996 102.715C130.996 102.715 127.835 104.866 126.648 112.362",
    stroke: "#75AEC6",
    strokeWidth: 0.84067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3203 103.914C44.3203 103.914 48.9374 115.539 48.6377 121.547",
    stroke: "#75AEC6",
    strokeWidth: 0.84067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4062 105.701C41.4062 105.701 44.9453 107.148 47.6631 114.234",
    stroke: "#75AEC6",
    strokeWidth: 0.84067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M95.902 57.7545C94.7421 52.8273 93.8165 46.4336 93.8165 46.4336L75.5062 49.93C75.5062 49.93 75.6439 55.483 75.3164 59.1146C81.4881 55.4528 89.084 55.4872 95.902 57.7545Z",
    fill: "#B57458"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9689 137.64C46.6348 136.672 47.1404 136.111 47.2848 134.92C47.4292 133.729 47.0812 124.432 47.0703 122.731C47.0594 121.029 66.2789 111.662 92.4951 112.082C118.711 112.502 131.548 119.854 132.072 120.664C132.596 121.474 133.481 128.615 133.842 130.157C134.117 132.031 133.913 133.946 133.249 135.72C132.072 137.64 110.137 131.549 91.4297 132.118C72.7218 132.687 49.3029 138.608 47.9689 137.64Z",
    fill: "#C4DCF0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3252 10.793C72.0904 10.793 66.973 21.387 68.1401 32.5195C69.3073 43.6522 75.4122 55.5928 84.4799 55.5928C93.5476 55.5928 98.1263 42.0362 98.1263 31.0831C98.1263 20.13 94.6249 10.793 82.3252 10.793Z",
    fill: "#C3886A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6771 22.5171C73.5058 23.3018 75.525 23.5308 77.483 23.1755C80.4759 22.5171 85.384 19.2849 85.384 19.2849C85.384 19.2849 90.4117 20.0348 93.1054 19.2849C93.5842 21.1404 94.1828 24.6719 95.739 27.3055C96.7161 29.1202 97.2687 31.133 97.3551 33.1922H98.0724C98.4356 31.3475 99.2194 29.6114 100.363 28.119C100.827 22.5769 100.981 17.2499 99.6468 12.9402C98.3128 8.63048 98.253 4.68018 90.2922 4.08158C82.3314 3.48298 80.5358 7.55319 80.5358 7.55319C80.5358 7.55319 70.6851 9.40879 67.5299 14.1374C64.3747 18.866 65.6219 24.6206 66.1704 26.3478C66.7189 28.075 67.9778 33.8897 67.9778 33.8897H69.5223C69.6816 32.3717 70.044 30.8819 70.5997 29.4603C71.6615 27.3109 72.0376 24.8872 71.6771 22.5171Z",
    fill: "#2D2304"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8242 316.154C59.8242 316.154 85.6047 302.983 116.99 302.703",
    stroke: "#57A0D8",
    strokeWidth: 1.68134,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4648 314.053C85.4648 314.053 109.284 308.309 125.117 314.053",
    stroke: "#57A0D8",
    strokeWidth: 1.68134,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M75.8672 106.514C84.6387 105.236 92.8708 101.506 99.6155 95.7539",
    stroke: "#75AEC6",
    strokeWidth: 0.84067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4336 120.841C49.4336 120.841 63.5712 112.07 87.7395 112.07C111.908 112.07 127.209 118.094 127.209 118.094C114.652 112.435 100.987 109.659 87.2173 109.969C73.9261 110.467 60.957 114.199 49.4336 120.841Z",
    fill: "#C4DCF0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M153.103 123.799L152.848 121.703C152.848 121.703 157.852 125.211 161.211 125.092C158.454 125.13 155.711 124.693 153.103 123.799Z",
    fill: "#C4DCF0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1451 117.523C24.1451 117.523 20.8255 123.679 16.0273 125.179C18.7165 124.814 24.021 122.092 24.021 122.092L23.1299 120.664L24.1451 117.523Z",
    fill: "#C4DCF0"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M154.231 216.613H151.082V222.492H154.231V216.613Z",
    fill: "#C4DCF0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6133 347.076C36.0421 348.749 39.7702 349.722 43.5794 349.936C47.3886 350.151 51.2023 349.603 54.7974 348.326C69.275 343.243 90.8801 339.576 111.728 340.076C132.576 340.576 141.663 339.451 145.405 329.576C141.529 345.201 135.694 347.076 122.998 347.451C110.302 347.826 92.8846 342.951 74.8433 346.576C56.802 350.201 40.1416 365.785 32.6133 347.076Z",
    fill: "#10548A"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M139.784 232.326C139.784 232.326 139.522 239.969 140.664 243.494C141.805 247.018 147.546 255.202 147.546 255.202L146.911 258.15C146.911 258.15 157.703 282.993 169.529 290.913C167.13 266.501 158.772 258.656 158.772 258.656L139.784 232.326Z",
    fill: "#10548A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M152.598 258.065C153.538 256.383 154.873 254.957 156.489 253.908C158.105 252.86 159.953 252.222 161.871 252.049",
    stroke: "#9CC0DC",
    strokeWidth: 1.07406,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M183.208 270.987C178.036 270.504 174.348 273.901 171.762 278.406",
    stroke: "#9CC0DC",
    strokeWidth: 0.77827,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M182.736 270.526C181.371 270.036 179.901 269.918 178.476 270.183C176.134 270.355 173.945 271.409 172.352 273.134",
    stroke: "#9CC0DC",
    strokeWidth: 0.77827,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M140.992 227.531C141.504 228.502 142.015 229.473 142.526 230.443C142.91 231.125 143.236 231.837 143.5 232.573C143.747 233.328 144.532 236.428 145.055 237.025",
    stroke: "#D89B7C",
    strokeWidth: 0.41278,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M142.703 224.559C143.3 225.479 143.897 226.4 144.494 227.32C144.938 227.964 145.326 228.645 145.656 229.354C145.97 230.083 147.031 233.099 147.607 233.647",
    stroke: "#D89B7C",
    strokeWidth: 0.41278,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M145.648 224.037C146.299 224.921 146.949 225.805 147.599 226.689C148.08 227.305 148.508 227.961 148.878 228.65C149.235 229.359 150.472 232.308 151.079 232.821",
    stroke: "#D89B7C",
    strokeWidth: 0.41278,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M156.363 237.273C156.6 237.908 157.059 238.436 157.654 238.759",
    stroke: "#D89B7C",
    strokeWidth: 0.41278,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOTpatient);
export default __webpack_public_path__ + "static/media/OTpatient.ddb0da33f167b376d0683f42924d325a.svg";
export { ForwardRef as ReactComponent };